export default "__VITE_ASSET__Dwduvh39__"